import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { useFeature, useViewer } from '@treams/treams-hooks';
import { FeatureName } from '@treams/treams-network';

import Note from './Note';
import NewNote from './NotesNewNote';
import PeerSharedNotes from './PeerSharedNotes';
import ViewerNotes from './ViewerNotes';

export default function Notes() {
	const hasOneOnOnes = useFeature(FeatureName.OneOnOnes);
	const viewer = useViewer();

	return (
		<Switch>
			<Route
				path={['/notes/new', '/notes/new/:collaboratorID', '/notes/new/subject/:subjectID']}
				exact
			>
				<NewNote />
			</Route>
			<Route exact path="/notes/archive">
				<ViewerNotes isArchived={true} />
			</Route>
			<Route exact path="/notes">
				{hasOneOnOnes ? <Redirect to="/notes/me" /> : <ViewerNotes />}
			</Route>
			<Route exact path="/notes/me">
				{hasOneOnOnes && viewer ? <ViewerNotes subjectID={viewer.id} /> : <Redirect to="/notes" />}
			</Route>
			<Route exact path="/notes/drafts">
				{hasOneOnOnes ? <ViewerNotes noSubject /> : <Redirect to="/notes" />}
			</Route>
			<Route exact path="/notes/collaborator/:collaboratorID">
				{({ match }) => <ViewerNotes collaboratorID={match!.params.collaboratorID!} />}
			</Route>
			<Route exact path="/notes/subject/:subjectID">
				{({ match }) => <ViewerNotes subjectID={match!.params.subjectID!} />}
			</Route>
			<Route exact path="/users/:id/notes">
				{({ match }) => <PeerSharedNotes userID={match!.params.id!} />}
			</Route>

			<Route path={['/notes/:id', '/users/:userID/notes/:id']}>
				{({ match }: RouteComponentProps<{ id: string; userID?: string }>) => (
					<Note
						key={match!.params.id!}
						id={match!.params.id!}
						userID={(match!.params as { userID: string }).userID}
					/>
				)}
			</Route>
		</Switch>
	);
}
